import header from '../modules/header/index';
import addScrollToTop from '../modules/addScrollToTop';
import NewsletterAction from '../modules/newsletterAction';
import checkoutJs from '../modules/checkout';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  checkoutJs();
  addScrollToTop();

  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });
})